import React from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AuthProvider, useAuth } from './src/hooks/useAuth';
import { LandingScreen } from './src/screens/LandingScreen';
import { AuthScreen } from './src/screens/AuthScreen';
import { LibraryScreen } from './src/screens/LibraryScreen';
import { ViewerScreen } from './src/screens/ViewerScreen';
import { PlansScreen } from './src/screens/PlansScreen';
import { WelcomeScreen } from './src/screens/WelcomeScreen';
import { EmbedScreen } from './src/screens/EmbedScreen';
import { AdminScreen } from './src/screens/AdminScreen';
import { SettingsScreen } from './src/screens/SettingsScreen';
import { AdminPill } from './src/components/AdminPill';

const Stack = createNativeStackNavigator();

// Loading screen while checking auth state
const LoadingScreen = () => (
  <View style={styles.loadingContainer}>
    <ActivityIndicator size="large" color="#C75B7A" />
  </View>
);

// Main navigator that checks auth state
const AppNavigator = () => {
  const { user, loading } = useAuth();

  // Show loading while checking auth
  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Stack.Navigator 
      initialRouteName={user ? "Library" : "Landing"}
      screenOptions={{
        headerShown: false,
        animation: 'fade',
      }}
    >
      {/* Public screens */}
      <Stack.Screen name="Landing" component={LandingScreen} />
      <Stack.Screen name="Auth" component={AuthScreen} />
      <Stack.Screen name="Plans" component={PlansScreen} />
      <Stack.Screen name="Welcome" component={WelcomeScreen} options={{ headerShown: false }} />
      
      {/* Protected screens - only accessible when logged in */}
      <Stack.Screen name="Library" component={LibraryScreen} />
      <Stack.Screen name="Viewer" component={ViewerScreen} />
      <Stack.Screen name="Embed" component={EmbedScreen} />
      <Stack.Screen name="Settings" component={SettingsScreen} />

      {/* Admin-only screen — guard handled inside component */}
      {user?.isAdmin && (
        <Stack.Screen name="Admin" component={AdminScreen} />
      )}
    </Stack.Navigator>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <NavigationContainer>
        <StatusBar style="auto" />
        <AppNavigator />
        <AdminPill />
      </NavigationContainer>
    </AuthProvider>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FBF8F4',
  },
});
